






















import Vue from 'vue'
import {
  Component, Prop, Emit,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import toDocument from '@/shared/directive/toDocument';
import ModalComponent from '@/shared/modal/modal.component.vue'
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import Contract from '@/domain/contract/entity/contract.entity';
import ContractGroupService from '@/domain/contract/service/contract-group.service';

@Component({
  filters: {
    toDocument(value: String): String {
      return toDocument(value);
    },
  },
  components: {
    ModalComponent,
    VbTooltipSlot,
    LabelSlot,
  },
})
export default class RemoveContractFromContractGroup extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true })
  businessUnitId!: string;

  @Prop({
    required: true,
  })
  contract!: Contract;

  @Emit('cancel')
  cancel(): void {}

  get options(): ModalOptions {
    return {
      title: 'Remover Contrato do Grupo de Contrato',
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Remover',
      okColor: 'redPrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 500,
      persistent: true,
    }
  }

  handleConfirm() {
    ContractGroupService.bindOrUnbindContractGroup(
      [this.contract.id],
    )
      .then((_response: any) => {
        VbSnackbarService.showSuccess('Contrato removido do Grupo de Contratos com sucesso!');
        this.$emit('ok');
      })
      .catch(VbSnackbarService.handleHttpError)
  }
}
